import { Component, _decorator } from 'cc';
import Dropdown from '../../../../common/scripts/Toolkit/Components/Dropdown/Dropdown';
import LocalizedLabel from '../../../../common/scripts/Toolkit/Components/LocalizedComponent/LocalizedLabel';

export enum TimeRangeOption {
    TODAY = 'TODAY',
    THREE_DAYS = 'THREE_DAYS',
    SEVEN_DAYS = 'SEVEN_DAYS',
    THIRTY_DAYS = 'THIRTY_DAYS',
}

export const ONE_DAY = 24 * 60 * 60 * 1000;
export const TIME_RANGE_OPTION_VALUE_MAP: { [value in TimeRangeOption]: number } = {
    [TimeRangeOption.TODAY]: ONE_DAY,
    [TimeRangeOption.THREE_DAYS]: 3 * 24 * 60 * 60 * 1000,
    [TimeRangeOption.SEVEN_DAYS]: 7 * 24 * 60 * 60 * 1000,
    [TimeRangeOption.THIRTY_DAYS]: 30 * 24 * 60 * 60 * 1000,
};

const { ccclass, property, requireComponent } = _decorator;
const languageDisplayOrder: TimeRangeOption[] = [TimeRangeOption.TODAY, TimeRangeOption.THREE_DAYS, TimeRangeOption.SEVEN_DAYS, TimeRangeOption.THIRTY_DAYS];
const languageDisplayKeyMap: { [value in TimeRangeOption]?: string } = {
    [TimeRangeOption.TODAY]: '',
    [TimeRangeOption.THREE_DAYS]: '',
    [TimeRangeOption.SEVEN_DAYS]: '',
    [TimeRangeOption.THIRTY_DAYS]: '',
};

@ccclass('TimeRangeDropdown')
@requireComponent(Dropdown)
export default class TimeRangeDropdown extends Component {
    @property
    protected readonly todayLocalizedKey = '';
    @property
    protected readonly daysLocalizedKey = '';

    private _dropdown: Dropdown<TimeRangeOption> = null;

    private get dropdown() {
        if (!this._dropdown) {
            this._dropdown = this.getComponent(Dropdown) as Dropdown<TimeRangeOption>;
        }
        return this._dropdown;
    }

    protected onLoad() {
        this._initializeLanguageDisplayKeyMap();
        this.dropdown.init(
            languageDisplayOrder,
            (displayName, selectedOption) => {
                displayName.getComponent(LocalizedLabel).key = languageDisplayKeyMap[selectedOption];
            },
            (node, option) => {
                node.getComponentInChildren(LocalizedLabel).key = languageDisplayKeyMap[option];
            },
        );
    }

    private _initializeLanguageDisplayKeyMap() {
        languageDisplayKeyMap[TimeRangeOption.TODAY] = this.todayLocalizedKey;
        languageDisplayKeyMap[TimeRangeOption.THREE_DAYS] = `${this.daysLocalizedKey}|3`;
        languageDisplayKeyMap[TimeRangeOption.SEVEN_DAYS] = `${this.daysLocalizedKey}|7`;
        languageDisplayKeyMap[TimeRangeOption.THIRTY_DAYS] = `${this.daysLocalizedKey}|30`;
    }
}
